import semver from 'semver'
export const isLatestMobileVersion = (verStr: string, latest: string) => {
  if (!verStr || !semver.valid(verStr)) {
    return true
  }
  return semver.gte(verStr, latest)
}
